import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { useViewport, useViewportLayout } from './useViewport.js';

const Viewport = ({ children, ...restProps }) => {
    const isMatched = useViewport({ ...restProps });
    return isMatched ? jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children }) : null;
};
const ViewportLayout = ({ children, ...restProps }) => {
    const isMatched = useViewportLayout({ ...restProps });
    return isMatched ? jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children }) : null;
};

export { Viewport, ViewportLayout };
//# sourceMappingURL=Viewport.js.map
